import React from 'react';
import { connect } from 'react-redux';
import CanvasJSChart from '../CanvasJSChart';
import LoadingControl from '../../../LoadingControl';
import moment from 'moment';
import 'moment-duration-format';
import { colors, dayMonthFormat } from '../../../../constants';

class ProgressOverTimeChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            averageQaScoreVisibility: true,
            customerSurveyCountVisibility: true,
            ticketCountVisibility: true,
            complianceVisibility: false,
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
    }

    toggleDataSeries(e) {
        if (e.dataSeries.name === "Average Qa Score") {
            this.setState({ averageQaScoreVisibility: !this.state.averageQaScoreVisibility });
        }
        else if (e.dataSeries.name === "customerSurveyCount") {
            this.setState({ customerSurveyCountVisibility: !this.state.customerSurveyCountVisibility });
        }
        else if (e.dataSeries.name === "ticketCount") {
            this.setState({ ticketCountVisibility: !this.state.ticketCountVisibility });
        }
    }

    render() {
        const { propId, progressOverTimeStats } = this.props;

        if (!progressOverTimeStats || !Array.isArray(progressOverTimeStats)) {
            return (<LoadingControl />);
        }

        const emptyDataPoint = progressOverTimeStats.map(t => {
            return {
                label: moment(t.subToDate).format(dayMonthFormat),
                y: undefined
            }
        });

        const averageQaScoreDataPoints = progressOverTimeStats.map(t => {
            return {
                label: moment(t.subToDate).format(dayMonthFormat),
                y: t.averageQaScore
            }
        });

        const customerSurveyCountDataPoints = progressOverTimeStats.map(t => {
            return {
                label: moment(t.subToDate).format(dayMonthFormat),
                y: t.customerSurveyCount
            }
        });

        const ticketCountDataPoints = progressOverTimeStats.map(t => {
            return {
                label: moment(t.subToDate).format(dayMonthFormat),
                y: t.ticketCount
            }
        });

        const emptyBar = {
            type: "column",
            name: "empty",
            showInLegend: false,
            dataPoints: emptyDataPoint
        };

        const averageQaScore = {
            type: "spline",
            color: colors.primary200,
            name: "Average Qa Score",
            showInLegend: true,
            dataPoints: this.state.averageQaScoreVisibility ? averageQaScoreDataPoints : emptyDataPoint
        };

        const customerSurveyCount = {
            type: "spline",
            color: colors.fourth200,
            name: "customerSurveyCount",
            showInLegend: true,
            dataPoints: this.state.customerSurveyCountVisibility ? customerSurveyCountDataPoints : emptyDataPoint
        };

        const ticketCount = {
            type: "spline",
            color: colors.secandary200,
            name: "ticketCount",
            showInLegend: true,
            dataPoints: this.state.ticketCountVisibility ? ticketCountDataPoints : emptyDataPoint
        };

        const options = {
            animationEnabled: true,
            exportEnabled: true,
            title: {
                text: ""
            },
            axisX: {
                //valueFormatString: "MMM",
                title: "",
                lineColor: "#4F81BC",
                labelFontColor: "#4F81BC",
                gridColor: '#fff'
            },
            axisY: {
                title: "",
                suffix: "%",
                lineColor: "#4F81BC",
                tickColor: "#4F81BC",
                labelFontColor: "#4F81BC",
                includeZero: false,
                gridColor: '#fff',
                minimum: 0,
                maximum: 109
            },
            legend: {
                cursor: "pointer",
                itemclick: this.toggleDataSeries
            },
            data: [averageQaScore]
        };//, ticketCount, customerSurveyCount

        return (
            <CanvasJSChart
                chartContainerId={propId}
                options={options}
            />
        );
    }
}

const select = state => ({ ...state.session });

export default connect(select)(ProgressOverTimeChart);
